module.exports = __webpack_public_path__ + "static/iphone-35b4e884f47c0af2c90b97bc8a2fbfdd.png";